import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../appStore';
import { fetchHierarchies } from '../../store/BranchingLogicHierarchiesSlice';

export const useBranchingLogicHierarchies = () => {
	const dispatch = useAppDispatch();
	const { selectableHierarchies } = useAppSelector((state) => state.questionBranchingLogicHierarchies);
	const { audienceSource } = useAppSelector((state) => state.survey.surveyEditModel);
	const hrisId = audienceSource.externalHrisId;

	useEffect(() => {
		if (!selectableHierarchies && hrisId) {
			dispatch(fetchHierarchies(hrisId));
		}
	}, [dispatch, selectableHierarchies, hrisId]);

	return useAppSelector((state) => state.questionBranchingLogicHierarchies);
};

export default useBranchingLogicHierarchies;
